import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
}), 'LineWeightTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/LineWeightTwoTone.js
// module id = 4484
// module chunks = 2